var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 88,
    viewBox: "0 0 48 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_389_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 74.9792C28.3264 74.9362 28.6852 74.9171 29.0666 74.9285C36.0965 74.2449 37.8958 66.8073 37.8958 63C37.8958 73.8333 44.4063 74.7188 47.7917 74.9792C39.9305 75.4705 37.9402 82.7595 37.8856 87.2275C37.8924 87.4801 37.8958 87.7376 37.8958 88C37.886 87.7541 37.8823 87.4958 37.8856 87.2275C37.6247 77.5428 32.4514 75.0303 29.0666 74.9285C28.7236 74.9619 28.3682 74.9792 28 74.9792Z",
    fill: "#FFEEB3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_389_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0.626735 22.9175 1.31549 22.8807 2.04785 22.9028C15.5453 21.5901 19 7.31004 19 0C19 20.8 31.5 22.5 38 23C22.9066 23.9433 19.0851 37.9382 18.9803 46.5167C18.9934 47.0017 19 47.4961 19 48C18.9811 47.5278 18.974 47.032 18.9803 46.5167C18.4795 27.9222 8.54672 23.0981 2.04785 22.9028C1.38939 22.9668 0.707032 23 0 23Z",
    fill: "#FFEEB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_389_50",
    x: 28,
    y: 63,
    width: 19.7916,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.70591 0 0 0 0 0.430794 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_389_50"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_389_50",
    x: 0,
    y: 0,
    width: 38,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.70591 0 0 0 0 0.430794 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_389_50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryStarsIcon);
export default __webpack_public_path__ + "static/media/galleryStarsIcon.ae086dc1d24467e0633afe49628b75ea.svg";
export { ForwardRef as ReactComponent };